// eslint-disable-next-line import/no-cycle
import store from '@/store';

// eslint-disable-next-line import/prefer-default-export
export function checkIfRegisterDataCorrect(to, from, next) {
  if (store.state.auth.registerDataValid) {
    next();
  } else {
    next('/auth/register');
  }
}
